/* Competitor Matrix elements ----------------------------------------------- */
const competitorMatrix = document.querySelector(".competitorMatrix");

const competitorMatrixThrottle = (func, time = 100) => {
  let lastTime = 0;
  return () => {
    const now = new Date();
    if (now - lastTime >= time) {
      func();
      time = now;
    }
  };
};

const validateCompetitorMatrixContentScroll = () => {
	if (!competitorMatrix) return;

	const competitorMatrixHeader = competitorMatrix.querySelector(".competitorMatrix-header");
	const competitorMatrixItems = competitorMatrix.querySelector(".competitorMatrix-items");
	competitorMatrixHeader.addEventListener("scroll", competitorMatrixThrottle(function(){
		competitorMatrixItems.scrollLeft = competitorMatrixHeader.scrollLeft;
	}, 100));
	competitorMatrixItems.addEventListener("scroll", competitorMatrixThrottle(function(){
		competitorMatrixHeader.scrollLeft = competitorMatrixItems.scrollLeft;
	}, 100));
};
validateCompetitorMatrixContentScroll();

// const validateCompetitorMatrixHeader = () => {
// 	if (!competitorMatrix) return;

// 	const windowY = window.scrollY;
// 	const windowH = window.innerHeight;
// 	const competitorMatrixTop = competitorMatrix.getBoundingClientRect().top;
// 	const competitorMatrixHeight = competitorMatrix.offsetHeight;
// 	const competitorMatrixHeader = competitorMatrix.querySelector(".competitorMatrix-header");

// 	if (competitorMatrixHeader.offsetHeight > competitorMatrixTop) {
// 		competitorMatrixHeader.classList.add("is-fixed");
// 		if (windowY < (competitorMatrixTop + competitorMatrixHeight + windowY)) {
// 			competitorMatrixHeader.classList.remove("is-hidden");
// 		} else {
// 			competitorMatrixHeader.classList.add("is-hidden");
// 		}
//  	} else {
// 		competitorMatrixHeader.classList.remove("is-fixed");
// 	}
// };
// window.addEventListener("scroll", competitorMatrixThrottle(validateCompetitorMatrixHeader, 100));